import { render, staticRenderFns } from "./BusinessRegistration.vue?vue&type=template&id=2fedd712"
import script from "./BusinessRegistration.vue?vue&type=script&lang=js"
export * from "./BusinessRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports